module.exports = __webpack_public_path__ + "static/conduction-832707d8a6083bcd68995c081148915c.png";